import React from 'react'
import { graphql } from 'gatsby'
import style from './cta.mod.scss'
import Img from 'gatsby-image'
import { Button } from '@components'

const Cta = ({ ctaItem, pricing = false }) => {
  const { heading, image, mobileImage, link, pricingImage } = ctaItem
  const modifiers = []

  pricing && modifiers.push(style[`cta--pricing`])

  const imageSources = [
    mobileImage.fluid,
    {
      ...(pricing ? pricingImage.fluid : image.fluid),
      media: `(min-width: 700px)`
    }
  ]

  return (
    <div className={[style.cta, ...modifiers].join(' ')}>
      <div className={style.cta__wrap}>
        <div className={style.cta__image}>
          <Img fluid={imageSources} />
        </div>
        <div className={style.cta__content}>
          <h2>{heading}</h2>
          <Button to={link?.link?.path || link?.url}>{link.displayText}</Button>
        </div>
      </div>
    </div>
  )
}

export default Cta
export const query = graphql`
  fragment Cta on DatoCmsCta {
    id
    padding
    background
    model {
      apiKey
    }
    ctaItem: link {
      ...CtaItem
    }
  }

  fragment CtaItem on DatoCmsCtaItem {
    id
    heading
    image {
      fluid(maxWidth: 1655, imgixParams: { fit: "crop", w: "1655", h: "633" }) {
        ...GatsbyDatoCmsFluid
      }
    }
    pricingImage: image {
      fluid(maxWidth: 1655, imgixParams: { fit: "crop", w: "1655", h: "820" }) {
        ...GatsbyDatoCmsFluid
      }
    }
    mobileImage: image {
      fluid(maxWidth: 375, imgixParams: { fit: "crop", w: "375", h: "650" }) {
        ...GatsbyDatoCmsFluid
      }
    }
    link {
      ...Link
    }
    internalTitle
  }
`
